// CtaCard — full-bleed image card with eyebrow + display title + body + circle arrow.
// Used on Home for the two giant SOLO / SQUAD picks.
// Ported from design-canon/project/src/screens-flow.jsx → HomeScreen .home-cta.

import type { CSSProperties, ReactNode } from 'react'

type Props = {
  onClick: () => void
  /**
   * Full CSS `background` shorthand. Caller is responsible for layering
   * the gradient over the photo so text stays legible (see canon's
   * `linear-gradient(...) 0% 100%, url(/cards/start-card.jpg) cover, color`).
   */
  background: string
  /** Text + arrow color. */
  color: 'ink' | 'paper'
  eyebrow: string
  title: string
  body: ReactNode
  /** Accessible label for the whole tap target. */
  ariaLabel: string
  disabled?: boolean
  testId?: string
}

export function CtaCard({
  onClick,
  background,
  color,
  eyebrow,
  title,
  body,
  ariaLabel,
  disabled,
  testId,
}: Props) {
  const fg = color === 'paper' ? 'var(--paper)' : 'var(--ink)'
  const style: CSSProperties = {
    background,
    color: fg,
  }
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
      className="home-cta"
      style={style}
    >
      <div className="cta-inner">
        <span className="eyebrow" style={{ color: fg }}>
          {eyebrow}
        </span>
        <span className="cta-title">{title}</span>
        <span className="body-sm cta-body" style={{ color: fg }}>
          {body}
        </span>
      </div>
      <span
        className="cta-arrow"
        aria-hidden
        style={
          color === 'paper' ? { color: 'var(--paper)', borderColor: 'var(--paper)' } : undefined
        }
      >
        →
      </span>
    </button>
  )
}
